export default __webpack_public_path__ + "static/media/bx_building.690db4d7.svg";